import AgentAssistedMemberIdRequest from 'interfaces/AgentAssistedMemberIdRequest';
import AgentAssistedPcpChangeRequest from 'interfaces/AgentAssistedPcpChangeRequest';
import { getAuthHeaders, getSearchParamsString } from './api';
import { handleResponseConversionToJSON } from './utility';

const PAGE_SIZE = 15;

const changePcp = async (
    authToken: string,
    request: AgentAssistedPcpChangeRequest
) => {
    const headers = getAuthHeaders(authToken);

    return await fetch('api/MemberServices/ChangePcp', {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
    }).then(handleResponseConversionToJSON);
};

const getPcpChangeRequests = async (
    authToken: string,
    memberId: string,
    page: number,
    pageSize: number = PAGE_SIZE,
    abortSignal?: AbortSignal
) => {
    const headers = getAuthHeaders(authToken);

    return await fetch(
        `api/MemberServices/GetPcpChangeRequestHistory?${getSearchParamsString({
            memberId,
            skip: (page ?? 0) * pageSize,
            take: pageSize,
        })}`,
        {
            method: 'GET',
            headers,
            signal: abortSignal,
        }
    ).then(handleResponseConversionToJSON);
};

const logShippingAddressMismatch = async (
    authToken: string,
    request: AgentAssistedMemberIdRequest
) => {
    const headers = getAuthHeaders(authToken);
    return await fetch('api/MemberServices/LogShippingAddressMismatch', {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
    });
};

const getSharedMemberCard = async (requestToken: string) => {
    return await fetch(`api/Member/GetSharedMemberCard?token=${requestToken}`, {
        method: 'GET',
    }).then(handleResponseConversionToJSON);
};

const submitMemberIdCardRequest = async (
    authToken: string,
    request: AgentAssistedMemberIdRequest
) => {
    const headers = getAuthHeaders(authToken);
    return await fetch('api/MemberServices/SubmitMemberIdCardRequest', {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
    }).then(handleResponseConversionToJSON);
};

const uploadMemberForm = async (
    authToken: string,
    memberId: string,
    memberName: string,
    documentType: number,
    form: File,
) => {
    const headers = getAuthHeaders(authToken);

    const formData = new FormData();
    formData.append('memberId', memberId);
    formData.append('memberName', memberName);
    formData.append('documentType', documentType.toString());
    formData.append('formDocument', form);

    return await fetch('api/MemberServices/UploadMemberFormDocument', {
        method: 'POST',
        headers: {
            Authorization: headers['Authorization'],
        },
        body: formData,
    }).then(handleResponseConversionToJSON);
};

export {
    changePcp,
    getPcpChangeRequests,
    logShippingAddressMismatch,
    getSharedMemberCard,
    submitMemberIdCardRequest,
    uploadMemberForm,
};
